import React from "react";
import Test from "./test";

const info = {
  difficulty: "easy",
  title: "Chop String",
  url: "chop-string",
  problemNumber: 1,
  problem: React.lazy(() => import(`./problem`)),
  test: Test,
  starter: `/**
* @param {string} str
* @param {number} k
* @return {string[]}
*/
    
/**
* Do not change this function body
* Do your changes within the function 
*/

return function chopStr(str, k) {
  // your code goes here        
};
`,
};

export default info;
